module.exports = __webpack_public_path__ + "static/media/notebook-pen.cd5230e7.jpg";